export const IN_REVIEW = 'review'
export const LIVE = 'live'
export const APPROVED = 'approved'
export const DENIED = 'denied'
export const INITIALIZED = 'initialized'
export const RENAME = 'Rename'
export const PUBLISH = 'Publish'
export const DELETE = 'Delete'
export const DEACTIVATE = 'Deactivate'
export const DUPLICATE = 'Duplicate'
export const REACTIVATE = 'Reactivate'
export const CANCEL_REVIEW = 'Cancel Review'

// -> regex
// eslint-disable-next-line no-useless-escape
export const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i

export const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i

// Free trial allowance shown in the in-app banner. Exported so the flows that
// spend a verification can invalidate it (PR #467 review 7).
export const FREE_TRIAL_STATUS_QUERY_KEY = 'free-trial-status'

export const FREE_TRIAL_TYPE = {
  Standard: 'standard',
  HeadToHead: 'head-to-head',
} as const

export type FreeTrialType = typeof FREE_TRIAL_TYPE[keyof typeof FREE_TRIAL_TYPE]

// The same E-Signature terms Grid Apply's signature step links to.
export const E_SIGNATURE_TERMS_URL = 'https://docs.gridverify.com/client/terms/e-sign.pdf'

export const SESSION_TIMEOUT = process.env.NEXT_PUBLIC_AUTH_TIMEOUT || 60 * 60 * 23.5 // 23.5 hours

// -> risk
export const RISK_CATEGORY_FILTER_NAMES = ['Risk 1', 'Risk 2', 'Risk 3']
export const RISK_FILTER_KEYS = ['riskCategory1', 'riskCategory2', 'riskCategory3']
export const RISK_CATEGORY_DESCRIPTIONS = [
  'Customers with a negative checking account leading to payment date',
  "Customers who don't have an checking account connected leading to payment date",
  'Customers who have failed the OFAC check',
]
export const NEGATIVE_BALANCE = 'negative balance'
export const PLAID_DISCONNECT = 'plaid disconnect'
export const OFAC = 'ofac'
export const BANKRUPTCY = 'bankruptcy'

// -> customer page views
export const OVERVIEW = 'overview'
export const VERIFICATION = 'verification'
export const TIMELINE = 'timeline'
export const METRICS = 'metrics'
export const REPORTING = 'reporting'
export const CUSTOMER_VIEWS = [OVERVIEW, VERIFICATION, TIMELINE, METRICS, REPORTING]

// -> modal - DEPRECATED
export const PENDING = 'pending'
export const COMPLETED = 'completed'
export const WAIVED = 'waived'
// export const SUCCESS = 'success' // below in tag constants
export const CONFIRMATION = 'confirmation'
export const ERROR = 'error'
export const AMOUNT = 'amount'

// -> timeline transactions
export const CANCEL_TRANSACTION = 'cancelTransaction'
export const WITHDRAW_DEPOSIT = 'withdrawDeposit'
export const WAIVE_FEE = 'waiveFee'
export const LATE_CHARGE = 'Late Charge'
export const SECURITY_DEPOSIT = 'security deposit'
export const PAYMENT = 'Payment'
export const AUTO_PAYMENT = 'Auto Payment'

// -> timeline statements
export const OVERRIDE_STATEMENT = 'overrideStatement'

// -> customer actions dropdown
export const OFFLINE_PAYMENT = 'offlinePayment'
export const SUBMIT_PAYMENT = 'submitPayment'
export const RECONCILE_STATUS = 'reconcileStatus'
export const ADJUST_CREDIT_LIMIT = 'adjustCreditLimit'
export const GENERATE_EXTERNAL_PAYMENT_LINK = 'generateExternalPaymentLink'
export const PASSWORD_RESET = 'passwordReset'
export const CLOSE_ACCOUNT = 'closeAccount'
export const CONFIRM_IDENTITY = 'confirmIdentity'
export const DEFER_PAYMENT = 'deferPayment'
export const REFRESH_BANK_ACCOUNT_BALANCE = 'refreshBankAccountBalance'
export const DISCONNECT_ACCOUNT = 'disconnectAccount'
export const SHOW_LINKED_ACCOUNT_ERRORS = 'showLinkedAccountErrors'
export const ADD_ACCOUNT = 'addAccountAndRoutingNumbers'
export const VERIFY_CIP = 'verifyCIP'
export const BACKDATE_PAYMENT = 'backdatePayment'
export const EDIT_NAME = 'editName'
export const EDIT_CONDITION = 'editCondition'
export const RAW_DATA = 'rawData'
export const PAYMENTS = 'payments'
export const EDIT_AUTOPAY = 'editAutopay'
export const REFUND_DEPOSIT = 'refundSecurityDeposit'
export const HAS_BALANCE = 'hasBalance'
export const AGREEMENTS = 'agreements'
export const SEND_PAYMENT_ARRANGEMENT = 'sendPaymentArrangement'
export const MARK_FAILED = 'markFailedPayment'
export const SEE_TRANSACTION = 'seeTransaction'
export const MANAGE_PENALTY_APR = 'managePenaltyAPR'
export const REQUEST_FACIAL_SCAN = 'requestFacialScan'
export const SEND_ACCOUNT_STATUS = 'sendAccountStatus'
export const EDIT_ACCOUNT_STATUS = 'editAccountStatus'

// -> reports
export const RECONCILIATION = 'reconciliation'
export const TRIAL_BALANCE = 'trial balance'
export const CHARGE_OFF = 'charge off'
export const TRANSACTION_MONITORING = 'transaction-monitoring'

// -> misc
export const DISCONNECTED = 'Disconnected'
export const EXPOSURE = 'exposure'
export const CUSTOMERS = 'customers'
export const INTEREST_EARNED = 'earned'
export const INTEREST = 'interest'
export const WAIT = 'wait'

// -> conditions
export const FRAUD = 'fraud'
export const FROZEN = 'frozen'
export const MILITARY = 'military'
export const TERM_LOAN = 'termLoan'
export const TOS_VIOLATION = 'tosViolation'

// -> raw actions
export const USER_DATA = 'userData'
export const PLAID_IDENTITY = 'plaidIdentity'
export const PLAID_ERRORS = 'plaidErrors'
export const FEATURES = 'features'
export const MONITOR = 'monitor'
export const CIP_RESPONSE = 'cipResponse'
export const PLAID_ITEM = 'plaidItem'
export const PAYPAL_HISTORY = 'paypalHistory'
export const PAYMENT_ARRANGEMENT = 'paymentAgreement'
export const BALANCE_RECONCILIATION = 'balanceReconciliation'

// -> email & phone
export const EDIT = 'edit'
export const ADD = 'add'
export const VERIFY = 'verify'
export const LOGIN = 'login'
export const BANK = 'bank'

// -> tag related
export const PRIMARY = 'primary'
export const SECONDARY = 'secondary'
export const SUCCESS = 'success'
export const WARNING = 'warning'
export const DANGER = 'danger'
export const GRAY = 'gray'
export const BROWN = 'brown'

// timeframe
export const PAST_24_HOURS = 'Past 24 Hours'
export const PAST_7_DAYS = 'Past 7 Days'
export const PAST_30_DAYS = 'Past 30 Days'
export const PREVIOUS_MONTH = 'Previous Month'
export const PAST_YEAR = 'Past Year'
export const YEAR_TO_DATE = 'Year to Date'

// -> Analytic Events
export const CREATE_ACCOUNT_EVENT = 'create_account'
export const LOGIN_EVENT = 'login'
export const CREATE_ACCOUNT_TOS_CTA_CLICKED = 'create_account_tos_continue_clicked'
export const CREATE_ACCOUNT_EMAIL_CTA_CLICKED = 'create_account_email_continue_clicked'
export const CREATE_ACCOUNT_2FA_CTA_CLICKED = 'create_account_2fa_continue_clicked'
export const CREATE_ACCOUNT_PASSWORD_CTA_CLICKED = 'created_account_password_continue_clicked'
export const CREATE_ACCOUNT_PROFILE_CTA_CLICKED = 'create_account_profile_continue_clicked'
export const CREATE_ACCOUNT_COMPANY_CTA_CLICKED = 'create_account_company_continue_clicked'
export const LOGIN_EMAIL_CTA_CLICKED = 'login_email_continue_clicked'
export const LOGIN_2FA_CTA_CLICKED = 'login_2fa_continue_clicked'
export const LOGIN_PASSWORD_CTA_CLICKED = 'login_password_continue_clicked'
export const WORKFLOW_TRANSACTION_CLICKED = 'workflow_transaction_clicked'
export const WORKFLOW_VERIFICATIONS_TAB_VIEWED = 'workflow_verifications_tab_viewed'
export const WORKFLOW_WEBHOOKS_TAB_VIEWED = 'workflow_webhooks_tab_viewed'
export const WORKFLOW_WEBHOOK_RESENT = 'workflow_webhook_resent'
export const WORKFLOW_WEBHOOK_TEST_SENT = 'workflow_webhook_test_sent'
export const WORKFLOW_SETTINGS_TAB_VIEWED = 'workflow_settings_tab_viewed'
export const WORKFLOW_RECIPIENT_ADDED = 'workflow_recipient_added'
export const WORKFLOW_RECIPIENT_UPDATED = 'workflow_recipient_updated'
export const WORKFLOW_RECIPIENT_DELETED = 'workflow_recipient_deleted'
export const CASE_CLICKED = 'case_clicked'
export const CREATE_WORKFLOW_NEW_WORKFLOW_CLICKED = 'create_workflow_new_workflow_clicked' // click "Create New Workflow" button
export const CREATE_WORKFLOW_CLICKED = 'create_workflow_clicked' // Enter workflow name step
export const CREATE_WORKFLOW_SELECT_INSIGHTS_CLICKED = 'create_workflow_select_insights_clicked'
export const CREATE_WORKFLOW_SAVE_CLICKED = 'create_workflow_save_changes_clicked'
export const SHOW_WORKFLOW_TRANSACTIONS_FILTER_CLICKED = 'show_workflow_transactions_filter_clicked'
export const CREATE_API_KEY_CLICKED = 'create_api_key_clicked'
export const ADD_IP_ADDRESS_CLICKED = 'add_ip_address_clicked'
export const INVITEE_CREATE_ACCOUNT_TOS_CTA_CLICKED = 'invitee_create_account_tos_continue_clicked'
export const INVITEE_CREATE_ACCOUNT_PASSWORD_CTA_CLICKED = 'invitee_create_account_password_continue_clicked'
export const INVITEE_CREATE_ACCOUNT_PROFILE_CTA_CLICKED = 'invitee_create_account_profile_continue_clicked'

// -> roles
export const SUPER = 'Super'
export const ADMIN = 'Admin'
export const MANAGER = 'Manager'
export const PROCESSOR = 'Processor'
export const BILLING = 'Billing'
export const OBSERVER = 'Observer'
// Observer+ (sc-9259): everything an Observer can see, plus acting on cases
// (approve, deny, comment, relate). Cannot run verifications.
export const CASE_REVIEWER = 'Case Reviewer'

export const DRAFT = 'draft'
export const DEACTIVATED = 'deactivated'
export const USER_PENDING = 'Pending'

export const NO_SUFFIX = ''
export const JR_SUFFIX = 'Jr.'
export const SR_SUFFIX = 'Sr.'
export const SUFFIXES = [NO_SUFFIX, JR_SUFFIX, SR_SUFFIX, 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX']
export const JR_SUFFIX_POSSIBILITIES = ['JR.', 'JR', 'JUNIOR']
export const SR_SUFFIX_POSSIBILITIES = ['SR.', 'SR', 'SENIOR']

export const LOCALE_COOKIE = 'NEXT_LOCALE'
export const LOCALE_COOKIE_MAX_AGE = 60 * 60 * 24 * 365
export const LANGUAGE_SEARCH_THRESHOLD = 5
// Labelled in their own script so anyone can find theirs. Spanish is served but not yet selectable:
// the backend can't store it until sc-10228.
export const SUPPORTED_LANGUAGES = [
  { code: 'en', nativeName: 'English', isSelectable: true },
  { code: 'ar', nativeName: 'العربية', isSelectable: true },
  { code: 'es', nativeName: 'Español', isSelectable: false },
] as const
